import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '../shared/shared.module';
import { CalendarRoutes } from './calendar-routing.module';
import { RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DemoMaterialModule } from '../demo-material-module';
import { CalendarService, GoogleLoginService } from './calendar.service';
import { NgbModalModule } from '@ng-bootstrap/ng-bootstrap';
import { FlatpickrModule } from 'angularx-flatpickr';
import { FlexLayoutModule } from '@angular/flex-layout';
import { NgGapiClientConfig, GoogleApiModule, NG_GAPI_CONFIG } from "ng-gapi";
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { JwtInterceptor } from '../authentication/helper/jwt.interceptor';
import { ErrorInterceptor } from '../authentication/helper/error.interceptor';
import { CalendarModule, DateAdapter } from 'angular-calendar';
import { adapterFactory } from 'angular-calendar/date-adapters/date-fns';
import { environment } from '../../environments/environment';
import { GoogleloginComponent } from './googlelogin/googlelogin.component';
import { MycalendarComponent } from './mycalendar/mycalendar.component';
import { AlertComponent } from '../shared/alert/alert.component';

let gapiClientConfig: NgGapiClientConfig = {
  client_id: environment.CLIENTID,
  discoveryDocs: ["https://www.googleapis.com/calendar/v3"],
  scope: [
    "https://www.googleapis.com/auth/calendar.readonly",
    "https://www.googleapis.com/auth/calendar"
  ].join(" ")
};

@NgModule({
  imports: [
    CommonModule,
    DemoMaterialModule,
    FlexLayoutModule,
    FormsModule,
    ReactiveFormsModule,
    SharedModule,
    RouterModule.forChild(CalendarRoutes),
    NgbModalModule.forRoot(),
    FlatpickrModule.forRoot(),
    HttpClientModule,
    CalendarModule.forRoot({
      provide: DateAdapter,
      useFactory: adapterFactory
    }),
    GoogleApiModule.forRoot({
      provide: NG_GAPI_CONFIG,
      useValue: gapiClientConfig
    }),
  ],
  declarations: [MycalendarComponent, GoogleloginComponent],
  exports: [MycalendarComponent, GoogleloginComponent],
  //entryComponents: [GoogleloginComponent],
  entryComponents: [AlertComponent],
  providers: [CalendarService, GoogleLoginService,
    { provide: HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true }]
})
export class CalendarsModule { }